import React from 'react';
import ReactGA from 'react-ga4';

export type Context = {
    trackSceneView: typeof ReactGA.send;
    trackEvent: typeof ReactGA.event;
    trackCustom: typeof ReactGA.ga;
};

// When not using GoogleAnalyticsProvider in the consumer project it will use below noop functions
const { Provider, Consumer } = React.createContext<Context>({
    trackSceneView: () => {},
    trackEvent: () => {},
    trackCustom: () => {},
});

type Props = {
    googleAnalyticsId: string;
};

class GoogleAnalyticsProvider extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        ReactGA.initialize(props.googleAnalyticsId);
    }

    render() {
        return (
            <Provider
                value={{
                    trackSceneView: (pathname: string) =>
                        ReactGA.send({
                            hitType: 'pageview',
                            page: pathname,
                            title: 'Page View',
                        }),
                    trackEvent: ReactGA.event,
                    trackCustom: ReactGA.ga,
                }}
            >
                {this.props.children}
            </Provider>
        );
    }
}

export { GoogleAnalyticsProvider, Consumer as GoogleAnalyticsConsumer };
